import { Injectable } from '@angular/core';
// eslint-disable-next-line no-restricted-imports
import { ActiveToast, IndividualConfig, ToastrService as NgxToastrService } from 'ngx-toastr';

export const ToastSuccessTitle = {
  LINK_COPIED: $localize`:@@t-info-link-copied:Link kopiert`,
  CREATED: $localize`:@@t-success-created:Erfolgreich erstellt`,
  DELETED: $localize`:@@t-success-deleted:Erfolgreich gelöscht`,
  HISTORY_DELETED: $localize`:@@t-success-history-deleted:Chatverlauf gelöscht`,
  SAVED: $localize`:@@t-success-saved:Erfolgreich gespeichert`,
  IMPORTED: $localize`:@@t-success-imported:Erfolgreich importiert`,
  LINK_GENERATED: $localize`:@@t-success-link-generated:Link erstellt`,
  GENERAL: $localize`:@@t-success-general:Erfolgreich`,
  DUPLICATED: $localize`:@@t-success-duplicated:Erfolgreich dupliziert`,
  RESET: $localize`:@@t-success-reset:Bot zurückgesetzt`
};

export const ToastErrorTitle = {
  CREATED: $localize`:@@t-error-created:Das Erstellen ist fehlgeschlagen. Versuche es erneut.`,
  SAVED: $localize`:@@t-error-saved:Deine Änderungen konnten nicht gespeichert werden. Versuche es erneut.`,
  LOADED: $localize`:@@t-error-loaded:Die Daten konnten nicht geladen werden. Prüfe deine Verbindung.`,
  DELETED: $localize`:@@t-error-deleted:Das Löschen ist fehlgeschlagen. Versuche es erneut.`,
  SENT: $localize`:@@t-error-sent:Die Nachricht konnte nicht gesendet werden. Versuche es erneut.`,
  OPENAI_ERROR: $localize`:@@t-error-openai-error:Die Anfrage konnte nicht ausgeführt werden. Versuche es erneut.`,
  IMPORTED: $localize`:@@t-error-imported:Der Import ist fehlgeschlagen. Versuche es erneut.`,
  LINK_GENERATED: $localize`:@@t-error-link-generated:Der Link konnte nicht erstellt werden. Versuche es erneut.`,
  ERROR_404: $localize`:@@t-error-error-404:Die angeforderte Ressource wurde nicht gefunden.`,
  ERROR_403: $localize`:@@t-error-error-403:Du hast keine Berechtigung für diese Aktion.`,
  ERROR_401: $localize`:@@t-error-error-401:Du bist nicht angemeldet. Bitte melde dich erneut an.`,
  ERROR_400: $localize`:@@t-error-error-400:Die Anfrage war fehlerhaft. Prüfe deine Eingaben.`,
  ERROR_429: $localize`:@@t-error-error-429:Zu viele Anfragen. Bitte warte einen Moment und versuche es dann erneut.`,
  ERROR_500: $localize`:@@t-error-error-500:Ein Serverfehler ist aufgetreten. Versuche es später erneut.`,
  ERROR: $localize`:@@t-error-error:Ein unerwarteter Fehler ist aufgetreten.`,
  GENERAL: $localize`:@@t-error-error-general:Fehler`
};

export const ToastInfoTitle = {
  SUPERVISOR_MSG: $localize`:@@t-info-supervisor-msg:Supervisor-Nachricht`,
  CHAT_DELETING: $localize`:@@t-info-chat-deleting:Chatverlauf wird gelöscht…`,
  REM_FEEDBACK: $localize`:@@t-info-rem-feedback:Feedback wurde entfernt`,
  ADD_FEEDBACK: $localize`:@@t-info-add-feedback:Danke für dein Feedback`,
  LINK_COPIED: $localize`:@@t-info-link-copied:Link kopiert`,
  TEXT_COPIED: $localize`:@@t-info-text-copied:Text kopiert`,
  SKILLID_COPIED: $localize`:@@t-info-skillid-copied:Skill-ID kopiert`,
  SAVED: $localize`:@@t-info-saved:Erfolgreich gespeichert`,
  BOT_UPDATED: $localize`:@@t-info-bot-updated:Bot wurde aktualisiert`,
  PROJECT_SECRETS_MISSING: $localize`:@@t-info-project-secrets-missing:Project-Secrets prüfen`
};

export const ToastWarningTitle = {
  // Den eintrag anpassen, sobald wir einen anwendungsfall für warning haben
  a: ""
};

export type ToastTitle = keyof (typeof ToastSuccessTitle & typeof ToastErrorTitle & typeof ToastInfoTitle & typeof ToastWarningTitle);

@Injectable({
  providedIn: 'root'
})
export class ToastrService {

  constructor(public baseToastr: NgxToastrService) { }

  /** show toast */
  public show<ConfigPayload = unknown>(title: ToastTitle, message?: string, override?: Partial<IndividualConfig<ConfigPayload>>, type?: string): ActiveToast<unknown> | null {
    return this.baseToastr.show(message, title, override, type);
  };

  /** show successful toast */
  public success<ConfigPayload = unknown>(title: keyof (typeof ToastSuccessTitle), message?: string, override?: Partial<IndividualConfig<ConfigPayload>>): ActiveToast<unknown> | null {
    return this.baseToastr.success(message, ToastSuccessTitle[title], override);
  };

  /** show error toast */
  public error<ConfigPayload = unknown>(title: keyof (typeof ToastErrorTitle), message?: string, override?: Partial<IndividualConfig<ConfigPayload>>): ActiveToast<unknown> | null {

    return this.baseToastr.error(message, ToastErrorTitle[title], override);
  };

  /** show info toast */
  public info<ConfigPayload = unknown>(title: keyof (typeof ToastInfoTitle), message?: string, override?: Partial<IndividualConfig<ConfigPayload>>): ActiveToast<unknown> | null {
    return this.baseToastr.info(message, ToastInfoTitle[title], override);
  };

  /** show warning toast */
  public warning<ConfigPayload = unknown>(title: keyof (typeof ToastWarningTitle), message?: string, override?: Partial<IndividualConfig<ConfigPayload>>): ActiveToast<unknown> | null {
    return this.baseToastr.warning(message, ToastWarningTitle[title], override);
  };

  /**
   * Remove all or a single toast by id
   */
  public clear(toastId?: number): void {
    this.baseToastr.clear(toastId);
  };

  /**
   * Remove and destroy a single toast by id
   */
  public remove(toastId: number): boolean {
    return this.baseToastr.remove(toastId);
  };




}
